__turbopack_context__.v({
  "pageContainer": "HomePage-module__vOmAEG__pageContainer",
  "productContainer": "HomePage-module__vOmAEG__productContainer",
  "title": "HomePage-module__vOmAEG__title",
});
